module.exports = __webpack_public_path__ + "img/middle_10.60a940a9.png";